export class Controller {

    /** @ngInject */
    constructor($state, $uibModal, Alert, CorporateSettingsService, SmsUsageReportModal) {
        this.$state = $state;
        this.$uibModal = $uibModal;
        this.Alert = Alert;
        this.CorporateSettingsService = CorporateSettingsService;
        this.SmsUsageReportModal = SmsUsageReportModal;
    }

    $onInit() {
        this.periodFilter = 'TODAY';
        this.startDate = new Date();
        this.endDate = new Date();
    }

    purchase() {
        if (this.settings.phoneNumber) {
            this.$uibModal.open({component: 'smsPurchase'});
        } else {
            this.Alert('danger', 'company.sms-services.phone-number-required');
        }
    }

    editSmsApproval() {
        this.$uibModal
            .open({
                component: 'editCorporateSmsSettings',
                resolve: {smsAutoApproval: () => this.settings.smsAutoApproval},
            }).result
            .then((smsAutoApproval) => {
                this.updatingSmsApproval = true;
                this.CorporateSettingsService
                    .save(this.companyId, {...this.settings, smsAutoApproval})
                    .then(() => this.$state.reload(this.$state.current))
                    .then(() => this.Alert('success', 'corporate.message.updated'))
                    .finally(() => this.updatingSmsApproval = false);
            });
    }

    getReport() {
        if (this.periodFilter === 'CUSTOM' && this.endDate < this.startDate) {
            this.Alert('danger', 'company.sms-services.invalid-date-range');
            return;
        }
        this.SmsUsageReportModal({
            periodFilter: this.periodFilter,
            startDate: this.startDate.toLocaleDateString(),
            endDate: this.endDate.toLocaleDateString(),
        });
    }

    turnOffSmsSupport() {
        this.$uibModal
            .open({component: 'companySmsServicesConfirmTurnOff'}).result
            .then(() => this.toggleSmsSupport(false))
            .then(() => this.$state.reload(this.$state.current))
            .then(() => this.Alert('success', 'company.sms-services.sms-support-turned-off'))
    }

    turnOnSmsSupport() {
        this.toggleSmsSupport(true)
            .then(() => this.$state.reload(this.$state.current))
            .then(() => this.Alert('success', 'company.sms-services.sms-support-turned-on'))
    }

    /** @private */
    toggleSmsSupport(smsSupported) {
        this.isToggling = true;
        return this.CorporateSettingsService
            .save(this.companyId, {...this.settings, smsSupported})
            .then(() => this.settings.smsSupported = smsSupported)
            .finally(() => this.isToggling = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sms-services/sms-services.controller.js